import React, { FunctionComponent } from 'react';
import InlineMessaging, {
  InlineMessagingTheme,
} from '@havenengineering/module-shared-library/dist/components/InlineMessaging/InlineMessaging';

export const NotAvailable: FunctionComponent = () => {
  return (
    <div>
      <h1 className="owners-heading-1">Drain down</h1>
      <InlineMessaging
        type={InlineMessagingTheme.INFO_THEME}
        title="Info"
        message="Please contact Park Owner Services for a paper form for your park."
        dismissible={false}
      />
    </div>
  );
};
